// src/backendServices/liveStreamManagment/api_hlsDirectory.ts
//
// L'annuaire des URL HLS libres déjà employées par un créateur — vit dans
// admin-api, PAS dans le microservice ffmpeg d'une chaîne (cf. hlsStreams
// dans api_microservice_sources.ts, propre à UNE chaîne). Même principe que
// api_xtreamDirectory.ts, pour les flux ajoutés par simple URL m3u8.

import { API_URLS } from '../urls';

export interface HlsDirectoryEntry {
  id        : number;
  url       : string;
  label     : string | null;
  createdAt : string;
  lastUsedAt: string;
}

/** L'annuaire HLS d'un créateur, du plus récemment employé au plus ancien. */
export const listHlsDirectory = async (adminId: number): Promise<HlsDirectoryEntry[]> => {
  const res = await fetch(`${API_URLS.getHlsDirectory}?admin_id=${adminId}`, { cache: 'no-store' });

  const data = await res.json().catch(() => ([]));

  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);

  return Array.isArray(data) ? data : [];
};

/**
 * Enregistre une URL dans l'annuaire, ou met à jour le label et
 * `lastUsedAt` de l'entrée existante (même URL pour ce créateur) — jamais
 * de doublon.
 */
export const saveHlsDirectoryEntry = async (
  adminId: number,
  entry  : { url: string; label?: string },
): Promise<HlsDirectoryEntry> => {
  const res = await fetch(API_URLS.saveHlsDirectoryEntry, {
    method  : 'POST',
    headers : { 'Content-Type': 'application/json' },
    body    : JSON.stringify({
      admin_id: adminId,
      url     : entry.url,
      label   : entry.label ?? '',
    }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`);

  return data as HlsDirectoryEntry;
};

export const deleteHlsDirectoryEntry = async (adminId: number, id: number): Promise<void> => {
  const res = await fetch(
    `${API_URLS.deleteHlsDirectoryEntry.replace('{id}', String(id))}?admin_id=${adminId}`,
    { method: 'DELETE' },
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error ?? `HTTP ${res.status}`);
  }
};
